<template>
  <div style="background-color: #f3f3f3">
    <v-overlay :value="loading" class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="error.show">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-data-table :headers="headers" :items="clientes" sort-by="nome" class="elevation-1" :loading="loadingLista"
      loading-text="Carregando..." :search="pesquisar" @dblclick:row="($event, { item }) => acessarCliente(item)"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, 250, 500, 1000, -1],
      }" :items-per-page="50" locale="pt" group-by="responsavel" item-key="nome" v-model="selecionados" show-select>
      <template v-slot:item.data_cadastro="{ item }">
        <span>{{ new Date(`${item.data_cadastro}T00:00:00.00`).toLocaleString('pt-br', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }) }}</span>
      </template>

      <template v-slot:item.situacao="{ item }">
        <span>{{
          item.situacao != "🟢"
          ? "Atrasado desde " + new Date(`${item.situacao}T00:00:00.00`).toLocaleString('pt-br', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
          : "🟢"
        }}</span>
      </template>

      <template v-slot:item.vencimento="{ item }">
        <span>{{ new Date(`${item.vencimento}T00:00:00.00`).toLocaleString('pt-br', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }) }}</span>
      </template>

      <template v-slot:item.regiao="{ item }">
        <span>{{ getRegiao(item) }}</span>
      </template>

      <template v-slot:top>
        <v-toolbar flat v-if="!loadingLista">
          <v-text-field v-model="pesquisar" append-icon="mdi-magnify" label="Pesquisar" single-line
            hide-details></v-text-field>

          <v-spacer></v-spacer>

          <v-tooltip bottom v-if="selecionados.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="multiAtualizacao()">
                <v-icon small> mdi-cloud </v-icon>
              </v-btn>
            </template>
            <span>Atualizar versão</span>
          </v-tooltip>

          <v-tooltip bottom v-if="selecionados.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="multiInformativo()">
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Alterar informativo</span>
          </v-tooltip>

          <v-tooltip bottom v-if="selecionados.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="multiNotificacao()">
                <v-icon small> mdi-bell </v-icon>
              </v-btn>
            </template>
            <span>Enviar notificação</span>
          </v-tooltip>

          <v-tooltip bottom v-if="selecionados.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="green" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="multiWhatsapp()">
                <v-icon small> mdi-whatsapp </v-icon>
              </v-btn>
            </template>
            <span>Enviar mensagem</span>
          </v-tooltip>

          <v-tooltip bottom v-if="!selecionados.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="listarClientes()">
                <v-icon small> mdi-refresh </v-icon>
              </v-btn>
            </template>
            <span>Atualistar lista</span>
          </v-tooltip>

          <v-tooltip bottom v-if="!selecionados.length">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="cadastrarCliente()">
                <v-icon small> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Cadastrar cliente</span>
          </v-tooltip>

        </v-toolbar>
      </template>

      <template v-slot:item.nome="{ item }">
        {{ item.simbolo }} {{ item.nome }}
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="dadosCliente(item)">
              mdi-information-variant
            </v-icon>
          </template>
          <span>Informações do cliente</span>
        </v-tooltip>
      </template>

      <template v-slot:item.opcoes="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="alterarVencimentoCliente(item)">
              mdi-calendar
            </v-icon>
          </template>
          <span>Alterar vencimento</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="alterarResponsavel(item)">
              mdi-account-convert
            </v-icon>
          </template>
          <span>Responsável</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="buscarAnalytics(item)">
              mdi-chart-areaspline
            </v-icon>
          </template>
          <span>Analytics</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.block === '🔴'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="desbloquearCliente(item)">
              mdi-lock-open
            </v-icon>
          </template>
          <span>Desbloquear</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="removerCliente(item)">
              mdi-close-circle-outline
            </v-icon>
          </template>
          <span>Remover</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="orange" dark class="my-1" @click="listarClientes">
          Tentar novamente
        </v-btn>
      </template>
    </v-data-table>
    <v-row justify="center" class="my-3"><v-row></v-row> </v-row>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.responsavel" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-account-convert</v-icon>
              <span class="headline">Responsável: {{ this.clienteSelecionado.nome }}</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.responsavel = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>

                <h3 class="mt-3 blue--text">Informações do responsável</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.nome_empresa" label="Empresa" hint="Nome da empresa ou do responsável"
                      type="text" filled required persistent-hint></v-text-field>
                  </v-col>
                </v-row>

                <h3 class="mt-3 blue--text">Limites</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.limite_emissao_fiscal_mes" label="Emissão fiscal - NFC-e"
                      hint="Limite de emissões fiscais de NFC-e por mês" type="number" filled required
                      persistent-hint></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.limite_emissao_fiscal_nfe_mes" label="Emissão fiscal - NF-e"
                      hint="Limite de emissões fiscais de NF-e por mês" type="number" filled required
                      persistent-hint></v-text-field>
                  </v-col>
                </v-row>

                <h3 class="mt-3 blue--text">Avançado</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.gamazap" label="Integração com o WhatsApp"
                      hint="Forçar o servidor a ser utilizado" type="url" filled required persistent-hint></v-text-field>
                  </v-col>
                </v-row>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.responsavel = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="alterarResponsavel(null)">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.analytics" max-width="800px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-areaspline</v-icon>
              <span class="headline">Analytics: {{ this.clienteSelecionado.nome }}</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.analytics = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <!-- Métricas Gerais -->
                <div class="mb-4">
                  <h3 class="mb-3 grey--text text--darken-2">
                    <v-icon left color="grey darken-2">mdi-information-outline</v-icon>
                    Métricas Gerais
                  </h3>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-card class="pa-4 text-center" elevation="2">
                        <v-icon size="40" color="blue">mdi-account-multiple</v-icon>
                        <div class="text-h4 font-weight-bold mt-2">{{ inputs.totalUsuarios || 0 }}</div>
                        <div class="text-caption grey--text">Total de Usuários</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-card class="pa-4 text-center" elevation="2">
                        <v-icon size="40" color="green">mdi-cart</v-icon>
                        <div class="text-h4 font-weight-bold mt-2">{{ inputs.totalPedidos || 0 }}</div>
                        <div class="text-caption grey--text">Total de Pedidos</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-card class="pa-4 text-center" elevation="2">
                        <v-icon size="40" color="orange">mdi-star</v-icon>
                        <div class="text-h4 font-weight-bold mt-2">{{ inputs.mediaAvaliacao || 0 }}</div>
                        <div class="text-caption grey--text">Média de Avaliação</div>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <!-- Métricas de Atividade -->
                <div class="mb-4">
                  <h3 class="mb-3 grey--text text--darken-2">
                    <v-icon left color="grey darken-2">mdi-chart-line</v-icon>
                    Atividade dos Últimos 30 Dias
                  </h3>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-card class="pa-4" elevation="2">
                        <div class="d-flex align-center">
                          <v-icon size="36" color="purple" class="mr-3">mdi-eye</v-icon>
                          <div>
                            <div class="text-h5 font-weight-bold">{{ inputs.visitas30dias || 0 }}</div>
                            <div class="text-caption grey--text">Visitas</div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-card class="pa-4" elevation="2">
                        <div class="d-flex align-center">
                          <v-icon size="36" color="teal" class="mr-3">mdi-receipt</v-icon>
                          <div>
                            <div class="text-h5 font-weight-bold">{{ inputs.fiscal30dias || 0 }}</div>
                            <div class="text-caption grey--text">Emissões Fiscais</div>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <!-- Faturamento -->
                <div class="mb-4">
                  <h3 class="mb-3 grey--text text--darken-2">
                    <v-icon left color="grey darken-2">mdi-cash-multiple</v-icon>
                    Faturamento
                  </h3>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-card class="pa-4" elevation="2" color="green lighten-5">
                        <div class="text-center">
                          <v-icon size="32" color="green darken-2">mdi-currency-usd</v-icon>
                          <div class="text-h6 font-weight-bold mt-2 green--text text--darken-2">
                            {{ formatarMoeda(inputs.fat7dias) }}
                          </div>
                          <div class="text-caption grey--text">Últimos 7 Dias</div>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-card class="pa-4" elevation="2" color="blue lighten-5">
                        <div class="text-center">
                          <v-icon size="32" color="blue darken-2">mdi-currency-usd</v-icon>
                          <div class="text-h6 font-weight-bold mt-2 blue--text text--darken-2">
                            {{ formatarMoeda(inputs.fat15dias) }}
                          </div>
                          <div class="text-caption grey--text">Últimos 15 Dias</div>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-card class="pa-4" elevation="2" color="purple lighten-5">
                        <div class="text-center">
                          <v-icon size="32" color="purple darken-2">mdi-currency-usd</v-icon>
                          <div class="text-h6 font-weight-bold mt-2 purple--text text--darken-2">
                            {{ formatarMoeda(inputs.fat30dias) }}
                          </div>
                          <div class="text-caption grey--text">Últimos 30 Dias</div>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <!-- Última Atualização -->
                <v-divider class="my-3"></v-divider>
                <div class="text-center">
                  <v-chip small color="grey lighten-3">
                    <v-icon small left>mdi-clock-outline</v-icon>
                    Última atualização: {{ new Date(inputs.data).toLocaleString("default") || 'Não disponível' }}
                  </v-chip>
                </div>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.analytics = false">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.notificacao" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-bell</v-icon>
              <span class="headline">Notificar {{ this.selecionados.length }} cliente(s)
                selecionado(s)</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.notificacao = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.url" label="URL" hint="Para onde ir ao clicar na notificação" type="url"
                      filled required persistent-hint></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea v-model="inputs.notificacao" label="Mensagem" hint="Mensagem da notificação" filled
                      required persistent-hint></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.notificacao = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="multiNotificacao(true)">
                Enviar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.cadastro" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-plus-circle</v-icon>
              <span class="headline">Cadastrar um novo cliente</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.cadastro = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>

                <h3 class="mt-3 blue--text">Loja</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.url" label="Nome da loja" :hint="'*.' + baseUrl" type="text" filled
                      required persistent-hint></v-text-field>

                    <v-select :items="versoes" v-model="inputs.versao" label="Versão" hint="Versão a ser instalada"
                      persistent-hint prepend-icon="mdi-axis-arrow" filled required class="mt-2"></v-select>
                  </v-col>
                </v-row>

                <h3 class="mt-3 blue--text">Responsável</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.email" class="mb-2" label="E-mail de acesso"
                      hint="Qual será o e-mail do responsável?" type="email" filled required
                      persistent-hint></v-text-field>

                    <v-text-field v-model="inputs.senha" class="mb-2" label="Senha de acesso"
                      hint="Qual será a senha do responsável?" type="password" filled required
                      persistent-hint></v-text-field>

                    <v-text-field v-model="inputs.nome" class="mb-2" label="Nome do responsável"
                      hint="Quem será o responsável pela loja?" type="text" filled required
                      persistent-hint></v-text-field>

                    <v-text-field v-model="inputs.telefone" class="mb-2" label="Telefone do responsável"
                      hint="Qual o telefone do responsável pela loja?" type="number" filled required
                      persistent-hint></v-text-field>
                  </v-col>
                </v-row>

                <h3 class="mt-3 blue--text">Opcionais</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.id_assinatura_asaas" class="mb-2" label="ID Assinatura Asaas"
                      hint="Caso queira identificar a assinatura" type="text" filled persistent-hint></v-text-field>

                    <v-select :items="this.planos" label="Plano" hint="Qual o plano do cliente?" filled
                      persistent-hint></v-select>

                    <v-text-field v-model="inputs.vendedor" class="mb-2" label="Vendedor"
                      hint="Caso queira identificar o vendedor" type="text" filled persistent-hint></v-text-field>

                    <v-textarea v-model="inputs.obs" label="Observação"
                      hint="Observações como específicação do plano, cardápio e criação da assinatura." class="mb-2"
                      rows="2" filled persistent-hint></v-textarea>

                    <v-text-field v-model="inputs.vencimento" label="Vencimento"
                      hint="Qual o próximo vencimento da mensalidade?" class="mb-2" type="date" filled required
                      persistent-hint></v-text-field>
                  </v-col>
                </v-row>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.cadastro = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="cadastrarCliente(true)">
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.informacao" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-pencil</v-icon>
              <span class="headline">Informar {{ this.selecionados.length }} cliente(s)
                selecionado(s)</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.informacao = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col>
                    <v-textarea v-model="inputs.informacao" label="Informativo"
                      hint="informação a ser exibida no painel do cliente ao entrar" filled required
                      persistent-hint></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.informacao = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="multiInformativo(true)">
                Alterar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.dados" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-information-variant</v-icon>
              <span class="headline">Informações do cliente</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.dados = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col>
                    <v-textarea v-model="inputs.dados" label="Cliente" hint="informação privadas do cliente" filled
                      required persistent-hint></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.dados = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="dadosCliente(null)">
                Alterar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.vencimento" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-calendar</v-icon>
              <span class="headline">Alterar vencimento: {{ this.clienteSelecionado.nome }}</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.vencimento = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col align="center">
                    <v-date-picker v-model="inputs.vencimento" required></v-date-picker>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.vencimento = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="alterarVencimentoCliente(null)">
                Alterar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.atualizar" max-width="600px">
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-cloud-upload</v-icon>
              <span class="headline">Atualizar {{ this.selecionados.length }} cliente(s)
                selecionado(s)</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.atualizar = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col>
                    <v-select :items="versoes" v-model="inputs.versao" label="Versão" hint="Versão a ser instalada"
                      persistent-hint prepend-icon="mdi-axis-arrow" filled required></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.atualizar = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="multiAtualizacao('confirmar')">
                Atualizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.confirmarAtualizar" max-width="600px">
          <v-card>
            <v-card-title class="warning white--text">
              <v-icon left color="white">mdi-alert</v-icon>
              <span class="headline">Confirmar atualização</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.confirmarAtualizar = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <div class="text-center py-4">
                  <v-icon size="80" color="warning">mdi-alert-circle-outline</v-icon>
                  <h3 class="mt-4 mb-3">Atenção!</h3>
                  <p class="text-body-1 mb-2">
                    Você está prestes a atualizar <strong>{{ this.selecionados.length }} cliente(s)</strong> para a
                    versão:
                  </p>
                  <v-chip color="primary" class="ma-2" large>
                    <v-icon left>mdi-tag</v-icon>
                    {{ inputs.versao === 'master' ? 'Estável - Última versão' : 'Experimental - Beta' }}
                  </v-chip>
                  <v-divider class="my-4"></v-divider>
                  <p class="text-body-2 grey--text text--darken-1">
                    Esta ação irá atualizar o sistema dos clientes selecionados.
                    Certifique-se de que deseja prosseguir com esta operação.
                  </p>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click="modal.confirmarAtualizar = false">
                Cancelar
              </v-btn>
              <v-btn color="warning" text @click="multiAtualizacao('executar')">
                <v-icon left>mdi-check</v-icon>
                Confirmar Atualização
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.remover" max-width="600px">
          <v-card>
            <v-card-title class="error white--text">
              <v-icon left color="white">mdi-close-circle-outline</v-icon>
              <span class="headline">Remover: {{ this.clienteSelecionado.nome }}</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.remover = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">

                    <v-select :items="motivos" v-model="inputs.motivo" label="Motivo" hint="Qual o motivo da remoção?"
                      class="mb-2" filled required persistent-hint></v-select>

                    <v-textarea v-model="inputs.obs" label="Observação" hint="Observações e mais detalhes da remoção."
                      class="mb-2" filled persistent-hint></v-textarea>

                    <v-text-field v-model="inputs.remover" label="Confirmação"
                      hint="digite EU CONFIRMO para continuar, esta ação é irreversível" class="mb-2" filled required
                      persistent-hint></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.remover = false">
                Cancelar
              </v-btn>
              <v-btn color="error" v-if="inputs.remover == 'EU CONFIRMO'" text @click="removerCliente('confirmar')">
                Remover
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.confirmarRemover" max-width="700px">
          <v-card>
            <v-card-title class="error white--text">
              <v-icon left color="white">mdi-alert-octagon</v-icon>
              <span class="headline">Confirmar remoção do cliente</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.confirmarRemover = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <div class="text-center py-4">
                  <v-icon size="100" color="error">mdi-alert-octagon-outline</v-icon>
                  <h2 class="mt-4 mb-3 error--text">ATENÇÃO: AÇÃO IRREVERSÍVEL!</h2>

                  <v-card class="pa-4 my-4" outlined>
                    <div class="text-left">
                      <p class="text-h6 mb-2">
                        <v-icon color="error">mdi-store-remove</v-icon>
                        Cliente: <strong>{{ this.clienteSelecionado.nome }}</strong>
                      </p>
                      <p class="text-body-1 mb-2">
                        <v-icon small>mdi-comment-text</v-icon>
                        Motivo: <strong>{{ inputs.motivo }}</strong>
                      </p>
                      <p class="text-body-2 grey--text" v-if="inputs.obs">
                        <v-icon small>mdi-note-text</v-icon>
                        Observação: {{ inputs.obs }}
                      </p>
                    </div>
                  </v-card>

                  <v-divider class="my-4"></v-divider>

                  <v-alert type="warning" border="left" colored-border elevation="2" class="text-left">
                    <div class="font-weight-bold mb-2">
                      <v-icon left>mdi-backup-restore</v-icon>
                      IMPORTANTE: Faça backup antes de continuar!
                    </div>
                    <ul class="text-body-2">
                      <li>Todos os dados do cliente serão permanentemente removidos</li>
                      <li>Esta ação NÃO pode ser desfeita</li>
                      <li>Certifique-se de ter feito backup de todas as informações importantes</li>
                      <li>Verifique se há dados ou arquivos que precisam ser salvos</li>
                    </ul>
                  </v-alert>

                  <v-divider class="my-4"></v-divider>

                  <p class="text-h6 error--text font-weight-bold">
                    Tem certeza que deseja prosseguir com a remoção?
                  </p>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text large @click="modal.confirmarRemover = false">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
              <v-btn color="error" large @click="removerCliente('executar')">
                <v-icon left>mdi-delete-forever</v-icon>
                Sim, remover definitivamente
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.desbloquear" max-width="600px">
          <v-card>
            <v-card-title class="success white--text">
              <v-icon left color="white">mdi-lock-open</v-icon>
              <span class="headline">Desbloquear: {{ this.clienteSelecionado.nome }}</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.desbloquear = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="inputs.desbloquear" label="Confirmação"
                      hint="digite EU CONFIRMO para continuar" filled required persistent-hint></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.desbloquear = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" v-if="inputs.desbloquear == 'EU CONFIRMO'" text
                @click="desbloquearCliente('confirmar')">
                Desbloquear
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.whatsapp" max-width="600px">
          <v-card>
            <v-card-title class="success white--text">
              <v-icon left color="white">mdi-whatsapp</v-icon>
              <span class="headline">Enviar mensagem para {{ this.selecionados.length }} cliente(s)
                selecionado(s)</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.whatsapp = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <v-row>
                  <v-col>
                    <v-textarea v-model="inputs.mensagemWhatsapp" label="Mensagem" hint="Texto a ser enviado via WhatsApp"
                      filled required persistent-hint></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.whatsapp = false">
                Cancelar
              </v-btn>
              <v-btn color="success" text @click="multiWhatsapp(true)">
                Enviar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.confirmarDesbloquear" max-width="700px">
          <v-card>
            <v-card-title class="warning white--text">
              <v-icon left color="white">mdi-alert</v-icon>
              <span class="headline">Confirmar desbloqueio da loja</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.confirmarDesbloquear = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <div class="text-center py-4">
                  <v-icon size="100" color="warning">mdi-alert-circle-outline</v-icon>
                  <h2 class="mt-4 mb-3 warning--text">ATENÇÃO!</h2>

                  <v-card class="pa-4 my-4" outlined>
                    <div class="text-left">
                      <p class="text-h6 mb-2">
                        <v-icon color="success">mdi-lock-open</v-icon>
                        Cliente: <strong>{{ this.clienteSelecionado.nome }}</strong>
                      </p>
                    </div>
                  </v-card>

                  <v-divider class="my-4"></v-divider>

                  <v-alert type="warning" border="left" colored-border elevation="2" class="text-left">
                    <div class="font-weight-bold mb-2">
                      <v-icon left>mdi-cash-multiple</v-icon>
                      IMPORTANTE: Cobrança será iniciada!
                    </div>
                    <ul class="text-body-2">
                      <li>Ao desbloquear esta loja, ela poderá efetuar vendas normalmente</li>
                      <li><strong>A cobrança será iniciada e você será cobrado na próxima fatura</strong></li>
                      <li>Certifique-se de que o cliente está ciente desta ação</li>
                      <li>Esta ação não pode ser desfeita</li>
                    </ul>
                  </v-alert>

                  <v-divider class="my-4"></v-divider>

                  <p class="text-h6 warning--text font-weight-bold">
                    Confirma o desbloqueio desta loja?
                  </p>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text large @click="modal.confirmarDesbloquear = false">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
              <v-btn color="success" large @click="desbloquearCliente('executar')">
                <v-icon left>mdi-lock-open</v-icon>
                Sim, desbloquear e iniciar cobrança
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import {
  fetchApiClientes,
  alterarVersaoSistema,
  cadastrarSistema,
  enviarNotificacaoSistema,
  alterarResponsavelSistema,
  alterarDadosClienteSistema,
  alterarInformativoDoCliente,
  alterarVencimentoSistema,
  removerSistema,
  desbloquearSistema,
  loginSistema,
  enviarMensagem,
} from "../../services/api";
import { verificarSessao, encerrar, sleep } from "../../utils/utils";

import FormData from "form-data";

export default {
  name: "Lista",
  data() {
    return {
      headers: [
        {
          text: "Link",
          align: "start",
          value: "nome",
        },
        { text: "Loja", value: "analytics.endereco.nome" },
        { text: "CNPJ", value: "analytics.endereco.cnpj" },
        { text: "Bairro", value: "analytics.endereco.bairro" },
        { text: "Região", value: "regiao" },
        { text: "Versão", value: "versao" },
        { text: "Cadastro", value: "data_cadastro" },
        { text: "Mensalidade", value: "situacao" },
        { text: "Próx. vencimento", value: "vencimento" },
        { text: "Estabelecimento", value: "status" },
        { text: "Manutenção", value: "manutencao" },
        { text: "Cache", value: "cache" },
        { text: "Logs", value: "logs" },
        { text: "Opções", value: "opcoes", sortable: false, width: "150px" },
      ],
      pesquisar: "",
      loading: false,
      loadingLista: true,
      error: {
        show: false,
        message: "",
        title: "",
      },
      versoes: [],
      motivos: [
        "Fechamento da loja em definitivo",
        "Pausa temporária da loja",
        "Insatisfação",
        "Troca do sistema",
        "Outro",
      ],
      clientes: [],
      inputs: {},
      clienteSelecionado: {},
      modal: {
        notificacao: false,
        informacao: false,
        vencimento: false,
        remover: false,
        confirmarRemover: false,
        dados: false,
        atualizar: false,
        confirmarAtualizar: false,
        responsavel: false,
        cadastro: false,
        analytics: false,
        desbloquear: false,
        confirmarDesbloquear: false,
        whatsapp: false,
      },
      token: localStorage.getItem("token"),
      moneyOptions: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
      },
      selecionados: [],
    };
  },
  async created() {
    window.addEventListener("offline", () => (this.loading = true));
    window.addEventListener("online", () => (this.loading = false));
    /**
     *
     */
    verificarSessao(this.listarClientes);
    setTimeout(verificarSessao, 1 * 60000);
    /**
     *
     */
    console.info({
      "versao": this.versao,
      "isDesenvolvimento": this.isDesenvolvimento,
      "isRevenda": this.isRevenda,
      "url": this.baseUrl,
      "dominio": this.dominio,
    });
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
      this.$root.$emit('global-loading', loading);
    },
    setError(error, title) {
      console.error(title, error?.response?.data);
      /**
       *
       */
      this.error = {
        show: true,
        title: title ? title : "Ops, falhou!",
        message: error?.response?.data
          ? error?.response?.data
          : "Falha não identificada, tente novamente.",
      };
    },
    getRegiao(item) {
      if (!item.analytics || !item.analytics.endereco) {
        return '-'
      }

      return `${item.analytics.endereco.cidade} - ${item.analytics.endereco.uf}`;
    },
    /**
     *
     *
     *
     */
    listarClientes() {
      this.loadingLista = true;
      fetchApiClientes(this.token)
        .then((response) => {
          this.loadingLista = false;
          this.clientes = response?.data?.clientes?.filter(loja => loja.ativo === true);
        })
        .catch((error) => {
          this.loadingLista = false;
          switch (error?.response?.status) {
            case 401:
              return this.sair();
            default:
              this.setError(error);
              break;
          }
        });
    },
    /**
     *
     *
     *
     */
    async carregarVersoes(callback) {
      this.versoes.push({
        text: "Estável - Última versão (recomendado)",
        value: "master",
      });
      this.versoes.push({
        text: "Experimental - Beta",
        value: "beta",
      });
      this.versoes.push({
        text: "Integrações - Beta",
        value: "feat-integracoes",
      });
      callback();
    },
    acessarCliente(cliente) {
      window.open(loginSistema(cliente.nome, this.baseUrl, this.token));
    },
    /**
     *
     */
    alterarResponsavel(cliente) {
      this.modal.responsavel = !this.modal.responsavel;
      if (cliente !== null) {
        this.inputs = {};
        this.inputs = cliente.responsavelJson;
        this.clienteSelecionado = cliente;
        return;
      }
      /**
       *
       */
      this.setLoading(true);
      alterarResponsavelSistema(
        this.clienteSelecionado.nome,
        this.baseUrl,
        {
          responsavel: this.inputs,
          token: this.token,
        }
      )
        .then(() => {
          this.setLoading(false);
          this.listarClientes();
        })
        .catch((error) => {
          this.setLoading(false);
          this.setError(error);
        });
    },
    /**
     *
     */
    buscarAnalytics(cliente) {
      this.modal.analytics = !this.modal.analytics;
      if (cliente !== null) {
        this.clienteSelecionado = cliente;
        this.inputs = {};
        this.inputs.data = new Date(this.inputs.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        if (cliente.analytics !== null) {
          this.inputs = cliente.analytics;
        }
        return;
      }
    },
    /**
     *
     */
    dadosCliente(cliente) {
      this.modal.dados = !this.modal.dados;
      if (cliente !== null) {
        this.inputs = {};
        this.inputs.dados = cliente.dados;
        this.clienteSelecionado = cliente;
        return;
      }
      /**
       *
       */
      this.setLoading(true);
      alterarDadosClienteSistema(
        this.clienteSelecionado.nome,
        this.baseUrl,
        {
          cliente: this.inputs.dados,
          token: this.token,
        }
      )
        .then(() => {
          this.setLoading(false);
          this.listarClientes();
        })
        .catch((error) => {
          this.setLoading(false);
          this.setError(error);
        });
    },
    alterarVencimentoCliente(cliente) {
      this.modal.vencimento = !this.modal.vencimento;
      if (cliente !== null) {
        this.inputs = {};
        this.inputs.vencimento = cliente.vencimento;
        this.clienteSelecionado = cliente;
        return;
      }
      /**
       *
       */
      this.setLoading(true);
      alterarVencimentoSistema(
        this.clienteSelecionado.nome,
        this.baseUrl,
        {
          vencimento: new Date(this.inputs.vencimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' }),
          token: this.token,
        }
      )
        .then(() => {
          this.setLoading(false);
          this.listarClientes();
        })
        .catch((error) => {
          this.setLoading(false);
          this.setError(error);
        });
    },
    removerCliente(step) {
      if (!step) {
        this.inputs = {};
        this.clienteSelecionado = step;
        this.modal.remover = !this.modal.remover;
        return;
      }

      if (typeof step === 'object' && step !== null) {
        this.inputs = {};
        this.clienteSelecionado = step;
        this.modal.remover = true;
        return;
      }

      if (step === 'confirmar') {
        if (this.inputs.remover !== 'EU CONFIRMO') {
          return false;
        }
        this.modal.remover = false;
        this.modal.confirmarRemover = true;
        return;
      }

      if (step === 'executar') {
        this.modal.confirmarRemover = false;
        this.setLoading(true);

        let data = new FormData();
        data.append("acao", "remover");
        data.append("ga_token", this.token);
        data.append("url", this.clienteSelecionado.nome);

        for (const input in this.inputs) {
          data.append(input, this.inputs[input]);
        }

        removerSistema(this.urlCadastro, data)
          .then(() => {
            this.setLoading(false);
            this.listarClientes();
          })
          .catch((error) => {
            this.setLoading(false);
            this.listarClientes();
            this.setError(error);
          });
      }
    },
    desbloquearCliente(step) {
      if (!step) {
        this.inputs = {};
        this.clienteSelecionado = step;
        this.modal.desbloquear = !this.modal.desbloquear;
        return;
      }

      if (typeof step === 'object' && step !== null) {
        this.inputs = {};
        this.clienteSelecionado = step;
        this.modal.desbloquear = true;
        return;
      }

      if (step === 'confirmar') {
        if (this.inputs.desbloquear !== 'EU CONFIRMO') {
          return false;
        }
        this.modal.desbloquear = false;
        this.modal.confirmarDesbloquear = true;
        return;
      }

      if (step === 'executar') {
        this.modal.confirmarDesbloquear = false;
        this.setLoading(true);

        let data = new FormData();
        data.append("acao", "desbloquear");
        data.append("ga_token", this.token);
        data.append("url", this.clienteSelecionado.nome);

        for (const input in this.inputs) {
          data.append(input, this.inputs[input]);
        }

        desbloquearSistema(this.urlCadastro, data)
          .then(() => {
            this.setLoading(false);
            this.listarClientes();
          })
          .catch((error) => {
            this.setLoading(false);
            this.listarClientes();
            this.setError(error);
          });
      }
    },
    async cadastrarCliente(start) {
      if (!start) {
        this.inputs = {};
        if (!this.versoes.length) {
          await this.carregarVersoes(() => { });
        }
        this.modal.cadastro = true;
        return;
      }
      /**
       *
       */
      if (!this.inputs.versao) {
        return;
      }
      this.setLoading(true);
      this.modal.cadastro = false;

      let data = new FormData();

      data.append("acao", "cadastrar");
      data.append("url", this.inputs.url);
      data.append("branch", this.inputs.versao);
      data.append("email", this.inputs.email);
      data.append("senha", this.inputs.senha);
      data.append("nome", this.inputs.nome);
      data.append("telefone", this.inputs.telefone);
      if (this.inputs.id_assinatura_asaas) {
        data.append("id_assinatura_asaas", this.inputs.id_assinatura_asaas);
      }
      if (this.inputs.vendedor) {
        data.append("vendedor", this.inputs.vendedor);
      }
      if (this.inputs.obs) {
        data.append("obs", this.inputs.obs);
      }
      if (this.inputs.vencimento) {
        data.append("vencimento", this.inputs.vencimento);
      }
      data.append("ga_token", this.token);

      cadastrarSistema(this.urlCadastro, data)
        .then(() => {
          this.setLoading(false);
          this.listarClientes();
        })
        .catch((error) => {
          this.modal.cadastro = true;
          this.setLoading(false);
          this.listarClientes();
          this.setError(error);
        });
    },
    /**
     *
     *
     *
     */
    async multiAtualizacao(step) {
      if (!step) {
        if (!this.selecionados.length) {
          return;
        }
        this.inputs = {};
        await this.carregarVersoes(() => (this.modal.atualizar = true));
        return;
      }

      if (step === 'confirmar') {
        if (!this.inputs.versao) {
          return false;
        }
        this.modal.atualizar = false;
        this.modal.confirmarAtualizar = true;
        return;
      }

      if (step === 'executar') {
        this.modal.confirmarAtualizar = false;
        this.setLoading(true);

        let i = 0;
        for await (const cliente of this.selecionados) {
          try {
            i++;

            let data = new FormData();
            data.append("branch", this.inputs.versao);
            data.append("acao", "atualizar");
            data.append("ga_token", this.token);
            data.append("url", cliente.nome);

            await alterarVersaoSistema(this.urlCadastro, data);

            this.selecionados = this.selecionados.filter(
              (selecionado) => selecionado.nome !== cliente.nome
            );
          } catch (error) {
            this.setError(
              error,
              `[${i}/${this.selecionados.length}] ${cliente.nome}`
            );
          }

          await sleep(1000);
        }

        this.listarClientes();
        this.setLoading(false);
      }
    },
    async multiNotificacao(start) {
      if (!start) {
        if (!this.selecionados.length) {
          return;
        }
        this.inputs = {};
        this.modal.notificacao = true;
        return;
      }
      /**
       *
       */
      if (!this.inputs.url || !this.inputs.notificacao) {
        return false;
      }
      /**
       *
       */
      this.setLoading(true);
      this.modal.notificacao = false;

      let i = 0;
      for await (const cliente of this.selecionados) {
        try {
          i++;
          await enviarNotificacaoSistema(cliente.nome, this.baseUrl, {
            icone: "bullhorn",
            tipo: "warning",
            url: this.inputs.url,
            notificacao: this.inputs.notificacao,
            token: this.token,
          });

          this.selecionados = this.selecionados.filter(
            (selecionado) => selecionado.nome !== cliente.nome
          );
        } catch (error) {
          this.setError(
            error,
            `[${i}/${this.selecionados.length}] ${cliente.nome}`
          );
        }

        await sleep(1000);
      }
      /**
       *
       */
      this.listarClientes();
      this.setLoading(false);
    },
    async multiInformativo(start) {
      if (!start) {
        if (!this.selecionados.length) {
          return;
        }
        this.inputs = {};
        this.modal.informacao = true;
        return;
      }
      /**
       *
       */
      if (!this.inputs.informacao) {
        return false;
      }
      /**
       *
       */
      this.setLoading(true);
      this.modal.informacao = false;

      let i = 0;
      for await (const cliente of this.selecionados) {
        try {
          i++;
          await alterarInformativoDoCliente(cliente.nome, this.baseUrl, {
            informacao: this.inputs.informacao,
            token: this.token,
          });

          this.selecionados = this.selecionados.filter(
            (selecionado) => selecionado.nome !== cliente.nome
          );
        } catch (error) {
          this.setError(
            error,
            `[${i}/${this.selecionados.length}] ${cliente.nome}`
          );
        }

        await sleep(1000);
      }
      /**
       *
       */
      this.listarClientes();
      this.setLoading(false);
    },
    async multiWhatsapp(start) {
      if (!start) {
        if (!this.selecionados.length) {
          return;
        }
        this.inputs = {};
        this.modal.whatsapp = true;
        return;
      }

      if (!this.inputs.mensagemWhatsapp) {
        return false;
      }

      this.setLoading(true);
      this.modal.whatsapp = false;

      let i = 0;
      for await (const cliente of this.selecionados) {
        try {
          i++;

          let telefone = cliente.analytics?.endereco?.telefone;
          if (!telefone) {
            throw 'O telefone não foi encontrado.';
          }

          await enviarMensagem(
            this.token,
            telefone,
            this.inputs.mensagemWhatsapp
          );

          this.selecionados = this.selecionados.filter(
            (selecionado) => selecionado.nome !== cliente.nome
          );
        } catch (error) {
          console.log(error)
          this.setError(
            error,
            `[${i}/${this.selecionados.length}] ${cliente.nome}`
          );
        }

        await sleep(1000);
      }

      this.listarClientes();
      this.setLoading(false);
    },
    sair() {
      return encerrar();
    },
    formatarMoeda(valor) {
      if (!valor && valor !== 0) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    },
  },
};
</script>

<style>
body {
  margin: 15px !important;
}
</style>
